module.exports = __webpack_public_path__ + "static/media/logo-footer.e63cac66.svg";